import { useState, useEffect, useCallback } from "react"
import { useAuth } from "@/hooks/useAuth"
import { listUsers } from "@/services/adminService"

/**
 * Fetches the user list and builds a userId → email lookup map.
 * Shared across admin screens to display email alongside userId.
 */
export function useUserMap() {
  const { token } = useAuth()
  const [userMap, setUserMap] = useState<Record<string, string>>({})

  const load = useCallback(async () => {
    if (!token) return
    try {
      const users = await listUsers(token)
      const map: Record<string, string> = {}
      for (const u of users) {
        map[u.userId] = u.email
      }
      setUserMap(map)
    } catch (e) {
      console.error("Failed to load user map:", e)
    }
  }, [token])

  useEffect(() => {
    load()
  }, [load])

  const resolveEmail = useCallback(
    (userId: string) => userMap[userId] || "",
    [userMap]
  )

  return { userMap, resolveEmail, refreshUserMap: load }
}
